import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInAnonymously } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDNsNGdMs_QQztF_Szpu47ma8UeAjlRUNI",
  authDomain: "planning-with-ai-da666.firebaseapp.com",
  projectId: "planning-with-ai-da666",
  storageBucket: "planning-with-ai-da666.firebasestorage.app",
  messagingSenderId: "1021109285748",
  appId: "1:1021109285748:web:7c051539ec2a73b0827221"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Ilova ochilganda Firebase Auth bilan anonim kirish —
// Firestore rules "request.auth != null" talab qilishi uchun
signInAnonymously(auth).catch(() => {});
